"use client";

type NumberCellProps = {
  value: number | string | null | undefined;
  fractionDigits?: number;
  placeholder?: string;
};

/**
 * 数値セルを表示します。
 *
 * `Number(null) === 0` の暗黙変換を避けて、本物の `0` と欠損値を見分けるため、
 * `null` / `undefined` / 空文字は placeholder として扱います。
 */
export const NumberCell = ({
  value,
  fractionDigits,
  placeholder = "-",
}: NumberCellProps) => {
  if (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return (
      <div className="text-muted-foreground text-right font-mono tabular-nums">
        {placeholder}
      </div>
    );
  }

  const num = Number(value);
  if (Number.isNaN(num)) {
    return (
      <div className="text-muted-foreground text-right font-mono tabular-nums">
        {placeholder}
      </div>
    );
  }

  const options =
    fractionDigits !== undefined
      ? {
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits,
        }
      : {};

  return (
    <div className="text-right font-mono tabular-nums">
      {num.toLocaleString(undefined, options)}
    </div>
  );
};
